import { usePopStore } from '@/stores/pop';
import { useUserStore } from '@/stores/user';

/**
 * 廣告代碼 ad_id，行銷有後台出這個代碼，通常給主網址，讓他們自己組合即可。組合完後，他們會轉短網址。
 * 由於目前短網址於簡訊會有白名單控管問題，故都需由 MIS 處理。
 * */ 
const checkAdIdParam = async () => {
    // console.log('Query ad_id');
    const userStore = useUserStore();
    const baseUrl: string = import.meta.env.VITE_FUNDAY_BASE_URL;

    // find ad_id value in window.location.search
    const searchParams = new URLSearchParams(window.location.search);
    const adId = searchParams.get('ad_id');
    if (adId) {
        userStore.adId = Number(adId);
        const response = await fetch(`${baseUrl}/Advertisement/AdImage?AdId=${adId}`);
        const adImageSrc = await response.json();

        sessionStorage.removeItem('isFromAd');
        sessionStorage.removeItem('adImagePcUrl');
        sessionStorage.removeItem('adImageSrcPhoneUrl');

        sessionStorage.setItem('isFromAd', 'true');
        if (adImageSrc.content && adImageSrc.content.pcUrl) {
            sessionStorage.setItem('adImagePcUrl', adImageSrc.content.pcUrl);
        }
        if (adImageSrc.content && adImageSrc.content.phoneUrl) {
            sessionStorage.setItem('adImageSrcPhoneUrl', adImageSrc.content.phoneUrl);
        }
        usePopStore().loadingStatus = false;
        
        return new Promise((resolve)=>resolve(true));
    } else {
        return new Promise((resolve) => resolve(false));
    }
};

export default checkAdIdParam;
